import type { PropsWithChildren } from 'react';
import { I18nextProvider } from 'react-i18next';

import i18n from '../config/i18n';

interface I18nProviderProps extends PropsWithChildren {}

export function I18nProvider(props: I18nProviderProps) {
    const { children } = props;

    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
